/* Concept A quick add: native <dialog>, /cart/add.js, cart count update. */
(function () {
  if (window.__uaQuickAdd) return;
  window.__uaQuickAdd = true;
  var opener = null;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-ua-qa-open]');
    if (open) {
      var dlg = document.getElementById(open.getAttribute('data-ua-qa-open'));
      if (!dlg || typeof dlg.showModal !== 'function') return; // fallback: follow link to product page
      e.preventDefault();
      opener = open;
      dlg.showModal();
      var first = dlg.querySelector('input[name="id"]:checked') || dlg.querySelector('[data-ua-qa-close]');
      if (first) first.focus();
      return;
    }
    var sw = e.target.closest('.ua-qa [data-ua-swap]');
    if (sw && window.fetch) { e.preventDefault(); swapProduct(sw); return; }
    if (e.target.closest('[data-ua-qa-close]')) { e.target.closest('dialog').close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('ua-qa')) { // backdrop click only
      var r = e.target.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) e.target.close();
    }
  });

  // Escape is handled natively by <dialog>; return focus on any close.
  document.addEventListener('close', function (e) {
    if (e.target.classList && e.target.classList.contains('ua-qa') && opener) { opener.focus(); opener = null; }
  }, true);


  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'NZD';
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur }).format(cents / 100); }
    catch (_) { return '$' + (cents / 100).toFixed(2); }
  }
  function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
  function swapProduct(link) {
    var form = link.closest('[data-ua-qa-form]');
    link.setAttribute('aria-busy', 'true');
    fetch(root + 'products/' + encodeURIComponent(link.getAttribute('data-ua-swap')) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (p) {
        var first = true;
        var opts = form.querySelector('[data-ua-qa-opts]');
        var legend = opts.querySelector('legend');
        opts.innerHTML = '';
        if (legend) opts.appendChild(legend);
        p.variants.forEach(function (v) {
          var chk = v.available && first; if (chk) first = false;
          opts.insertAdjacentHTML('beforeend',
            '<label class="ua-qa__opt' + (v.available ? '' : ' is-off') + '"><input type="radio" name="id" value="' + v.id + '"' +
            (v.available ? '' : ' disabled') + (chk ? ' checked' : '') + '><span class="ua-qa__opt-name">' + esc(v.title) +
            '</span><span class="ua-qa__opt-price">' + (v.available ? money(v.price) : 'Sold out') + '</span></label>');
        });
        form.querySelector('[data-ua-qa-title]').textContent = p.title;
        form.querySelector('[data-ua-qa-more]').href = p.url;
        form.querySelectorAll('[data-ua-swap]').forEach(function (a) { a.removeAttribute('aria-current'); });
        link.setAttribute('aria-current', 'true');
        form.querySelector('[data-ua-qa-msg]').textContent = p.title + ' selected.';
        var sel = opts.querySelector('input:checked'); if (sel) sel.focus();
      })
      .catch(function () { window.location.href = link.href; })
      .then(function () { link.removeAttribute('aria-busy'); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-ua-qa-form]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var msg = form.querySelector('[data-ua-qa-msg]');
    var fd = new FormData(form);
    if (!fd.get('id')) { msg.textContent = 'Choose a size first.'; return; }
    btn.setAttribute('aria-busy', 'true');
    msg.textContent = '';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-ua-cart-count], .cart-count, [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('ua:cart-updated', { detail: cart }));
        msg.textContent = 'Added to cart.';
        setTimeout(function () { var d = form.closest('dialog'); if (d && d.open) d.close(); }, 900);
      })
      .catch(function (err) { msg.textContent = (err && (err.description || err.message)) || 'Could not add to cart. Please try again.'; })
      .then(function () { btn.removeAttribute('aria-busy'); });
  });
})();
